import PageBanner from 'components/banners/PageBanner';
import React from 'react';
import { Col, Container, Image, Row } from 'react-bootstrap';
import teamWorkImage from 'assets/images/Trasnsportation-cap60.jpeg';
import styles from './programs.module.scss';
import { Helmet } from 'react-helmet';
import RequestDemoButton from 'components/RequestDemoButton';
const REPORT_DATA = [
  {
    title: 'Client',
    items: [
      'Order & Manage RIDES',
      'See the location of the vehicle on their phone – Fewer Calls to Dispatch!',
      'ETA’s per vehicle',
      '“5-minute away” notices – Cuts Driver wait time',
    ],
  },
  {
    title: 'Dispatch',
    items: [
      'Real-time, Interactive map',
      'Real-time manifest',
      'Customized Reports',
      'Optimized schedules & routes',
    ],
  },
  {
    title: 'Driver',
    items: [
      'Real time directions',
      'Choose Map or turn-by-turn directions',
      'Easy to view and use',
      'Fares automatically calculated',
    ],
  },
  {
    title: 'Admin',
    items: [
      'Fleet Maintenance Module',
      'Incidents Module',
      'HR Module',
      'Fixed Route and Fares set-up',
    ],
  },
];
// const FEATURE_DATA = [
//   {
//     id: '01',
//     title: 'Program Eligibility Calculator    ',
//   },
//   {
//     id: '02',
//     title: 'Priority Point Matrix',
//   },
//   {
//     id: '03',
//     title: 'Benefit Amount Calculation',
//   },
//   {
//     id: '04',
//     title: 'Automated Payment Creation',
//   },
//   {
//     id: '05',
//     title: 'Real-time Status Tracking',
//   },
//   {
//     id: '06',
//     title: 'Complete Integration with Other Agency Programs',
//   },
//   {
//     id: '07',
//     title: 'Integrated Check Printing System',
//   },
//   {
//     id: '08',
//     title: 'Automated Transmittal to Utility Vendors',
//   },
//   {
//     id: '09',
//     title: 'Track Energy Outreach Activities',
//   },
//   {
//     id: '10',
//     title: 'Unduplicated Client Count',
//   },

//   {
//     id: '11',
//     title: 'Complete Integration with Other Agency Programs',
//   },
//   {
//     id: '12',
//     title: 'Real-time Status Tracking',
//   },
// ];
function Transportation() {
  return (
    <div>
      <Helmet>
        <title>Transportation Data Management - CAP60</title>
        <meta
          name="description"
          content="CAP60 Ride provides a comprehensive transportation solution, integrating automated dispatching software to schedule rides, and manage fleets."
        />
        <meta
          name="keywords"
          content="transportation data management, cap60 transportation data management"
        />
      </Helmet>
      <PageBanner
        title="Transportation        "
        subtitle="ICAP60 RIDE: The 3-in-1 Transportation Data Management & Scheduling System"
      />
      <div className="floralbg-white">
        <Container className="overflow-auto">
          <CommunityServices />
        </Container>
      </div>
      <SampleReport data={REPORT_DATA} title="Transportation User Features" />
      <div className="floralbg-white">
        {/* <Container className="overflow-auto">
          <Features
            data={FEATURE_DATA}
            variant="primary"
            title="Features"
            subtitle="Dig in to know what make CAP60 Solutions unique and useful."
          />
        </Container> */}
      </div>
    </div>
  );
}
//
function CommunityServices() {
  return (
    <div className={styles.communityServicesWrap}>
      <Row className="align-items-center">
        <Col md="5">
          <Image src={teamWorkImage} fluid className="p-3 mb-4 mb-md-0" />
        </Col>
        <Col md="7">
          <div className="heading">
            <h2>
              Perfect for agencies offering NEMT, Paratransit and Fixed Route
              services{' '}
            </h2>
          </div>
          <p>
            The CAP60 Head Start module is a CSBG-integrated data management
            system that tracks all facets of child assessment, development and
            education. Track family data and take advantage of our Class
            observation (from Brooks Publishing) tracking and reporting
          </p>
          <p>
            CAP60 is the most technologically-advanced system for Process
            Automation, Data Collection and Agency Reporting; designed precisely
            to manage delegate agencies, school districts, programs and
            grantees.
          </p>
          <RequestDemoButton />
        </Col>
      </Row>
    </div>
  );
}

function SampleReport({ data, title }) {
  return (
    <div className={styles.sampleReportWrapper}>
      <Container>
        <div className="heading">{!!title && <h2> {title}</h2>}</div>
        <Row>
          {data.map((rdata, idx) => (
            <Col md="6" key={idx}>
              <div className={styles.reportList}>
                <h3>{rdata.title}</h3>
                <ul>
                  {rdata.items.map((item, idx) => (
                    <li key={idx}>{item}</li>
                  ))}
                </ul>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}
export default Transportation;
